import { Card, Icon } from '@weezevent/nacre';
import { React, useTranslation } from '../';

function Unavailable() {
    const { t } = useTranslation();
    return (
        <Card>
            <Card.EmptyState
                title={t('attendees.addAttendees.noRates')}
                subtitle={t('attendees.addAttendees.noRatesSubtitle')}
                icon={<Icon name="list" />}
                labelButton={t('attendees.addAttendees.createTarif')}
            />
        </Card>
    );
}

export default Unavailable;
